import React from "react";
import {
  FaCoins,
  FaSpinner,
  FaExclamationTriangle,
  FaTimes,
} from "react-icons/fa";

const PosOpenModal = ({
  openingCash,
  setOpeningCash,
  onSubmit,
  onClose,
  isSubmitting,
  shiftError,
}) => {
  return (
    /* Changed from fixed to absolute, dropped the z-index down so it locks inside the layout container */
    <div className="absolute inset-0 z-50 bg-slate-950/80 backdrop-blur-md flex items-center justify-center p-4">
      <div
        className="relative w-full max-w-md bg-slate-900 border border-white/10 rounded-2xl p-6 shadow-2xl text-slate-100 flex flex-col gap-4 z-10"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center">
          <h3 className="text-sm font-bold text-white tracking-wide uppercase flex items-center gap-2">
            <FaCoins className="text-emerald-400" /> Open Terminal
          </h3>
        </div>

        <p className="text-[11px] text-slate-500">
          You must input the initial starting cash balance to start selling on
          POS.
        </p>

        <form onSubmit={onSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <label className="text-[10px] uppercase font-bold tracking-wider text-slate-400">
              Opening Cash Amount (ETB)
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              required
              autoFocus
              value={openingCash}
              onChange={(e) => setOpeningCash(e.target.value)}
              placeholder="0.00"
              className="w-full bg-slate-950 border border-white/10 rounded-xl px-3 py-2.5 text-emerald-400 font-mono font-bold text-sm focus:outline-none focus:border-emerald-500/50"
            />
          </div>

          {shiftError && (
            <p className="text-[11px] text-red-400 flex items-center gap-1.5">
              <FaExclamationTriangle /> {shiftError}
            </p>
          )}

          <div className="flex gap-2">
            <button
              type="submit"
              disabled={isSubmitting}
              className="flex-1 py-2.5 bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-xs rounded-xl transition uppercase tracking-wider flex items-center justify-center gap-2"
            >
              {isSubmitting ? (
                <FaSpinner className="animate-spin" />
              ) : (
                "Open Session"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PosOpenModal;
